import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from 'modules/auth/containers/Landing';
import PageNotFound from 'partial/containers/PageNotFound';

function Public() {
  return (
    <Routes>
      <Route exact path="/" element={<Landing />} />
      <Route path="/logout" element={<Navigate to="/" />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

Public.propTypes = {};

export default Public;
